import { IServerOrder } from '@rbi-ctg/menu';
import { Currencies, PaymentISOs } from 'utils/form/constants';

import { IApplePayDetails } from '../../../features/payment/types';
import { IUseCartTip } from '../../order/hooks/use-cart-tip';

export enum ApplePayOutcome {
  SUCCESS = 'success',
  CANCELLED = 'cancelled',
  FAILURE = 'failure',
}

export enum ApplePayFailureReason {
  APPLE_PAY_SESSION_UNAVAILABLE = 'apple-pay-session-unavailable',
  CAN_MAKE_PAYMENTS_FALSE = 'can-make-payments-false',
  CAN_MAKE_PAYMENTS_ERROR = 'can-make-payments-error',
  ENABLE_APPLE_PAY_DISABLED = 'enable-apple-pay-disabled',
  ENABLE_APPLE_PAY_WEB_DISABLED = 'enable-apple-pay-web-disabled',
  REQUEST_ALREADY_ACTIVE = 'request-already-active',
  STORE_UNAVAILABLE = 'store-unavailable',
  MERCHANT_VALIDATION_FAILED = 'merchant-validation-failed',
  EMPTY_MERCHANT_SESSION = 'empty-merchant-session',
  MERCHANT_VALIDATION_COMPLETION_FAILED = 'merchant-validation-completion-failed',
  INVALID_AUTHORIZATION_DATA = 'invalid-authorization-data',
  AUTHORIZATION_FAILED = 'authorization-failed',
  SESSION_CONSTRUCTION_FAILED = 'session-construction-failed',
  SESSION_START_FAILED = 'session-start-failed',
  UNEXPECTED = 'unexpected',
}

export interface IApplePayResult {
  data?: IApplePayDetails;
  error?: string;
  outcome?: ApplePayOutcome;
  reason?: ApplePayFailureReason;
}

export interface IUseApplePay {
  prepaid?: boolean;
  handleApplePay?(result: IApplePayResult): Promise<void>;
  tipAmount?: IUseCartTip['tipAmount'];
  serverOrder?: IServerOrder | null;
}

export interface IRequestApplePayPayment {
  countryCode: PaymentISOs;
  currencyCode: Currencies;
  total: number;
  cartLabels?: string[];
  cartPrices?: number[];
}
